import { render } from "./UsersSelect.vue?vue&type=template&id=61abe6d2&scoped=true"
import script from "./UsersSelect.vue?vue&type=script&lang=js"
export * from "./UsersSelect.vue?vue&type=script&lang=js"

import "./UsersSelect.vue?vue&type=style&index=0&id=61abe6d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61abe6d2"]])

export default __exports__